import { FieldProps } from '~/pages/Observations/types'

export enum AssistActions {
  GENERATE = 'GENERATE',
  TRANSLATE = 'TRANSLATE',
  SPELLING = 'SPELLING',
  TRIM = 'TRIM',
  TONE = 'TONE',
  EXPAND = 'EXPAND',
}

export interface AssistModalProps extends FieldProps {
  postId: Nullable<number>
  postTitle?: string
  taggedChildren?: string
  postDescription: string
  postRichTextDescription: string
  assistAction: Playground.AssistActions
  closeAssistModal: (reason?: 'ON_INSERT' | 'ON_DISMISS') => void
}

export interface Question {
  id: number
  question: string
  questionType: string | null
  isOptional: boolean
  actions?: {
    title: string
    questionId: number
    questionSet: string
    value: string
  }[]
}
